var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "form",
    { on: { submit: _vm.addAgence } },
    [
      _c("v-text-field", {
        attrs: {
          type: "text",
          label: "Libellé Agence",
          value: _vm.getAgence.libelle,
        },
        on: { change: _vm.setLibelleAgence },
      }),
      _c("v-text-field", {
        attrs: {
          type: "number",
          label: "Id Agence (ERP)",
          value: _vm.getAgence.idERP,
        },
        on: { change: _vm.setIdAgence },
      }),
      _c("v-btn", { attrs: { type: "submit" } }, [_vm._v("Enregistrer")]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }